// app/src/lib/create-nav.js — PURE create-flow navigation helpers (CREATE-2). No imports, so
// the harness suite (harness/test/v2/create-flow.test.js) imports this file directly and pins
// both mappings. The SPA renders the server's `resume` pointer VERBATIM — it never re-derives
// where a draft left off; it only maps that pointer onto this app's routes.
//
//   resumeRoute(resume) — the CREATE-1 §5.2 resume contract → the app route to land on.
//     'result'     → /result/:runId          (self-contained: run id is in the URL)
//     'generating' → /create/generating/:jobId (self-contained: job id is in the URL)
//     'scripting'  → /create/script  \
//     'script'     → /create/script   |  these read the active draft id from the flow
//     'ideating'   → /create/ideas    |  context — the strip sets it before navigating.
//     'ideas'      → /create/ideas    |
//     'prompt'     → /                /
//
//   isFirstRun({ runs, drafts, brands }) — the first-run hero fires ONLY on a genuinely
//     empty account: zero real runs AND zero drafts AND zero brands (three real endpoints).

export function resumeRoute(resume) {
  const r = resume || {};
  switch (r.to) {
    case 'result':
      return r.run_id ? `/result/${encodeURIComponent(r.run_id)}` : '/content';
    case 'generating':
      return r.job_id ? `/create/generating/${encodeURIComponent(r.job_id)}` : '/create/script';
    case 'scripting':
    case 'script':
      return '/create/script';
    case 'ideating':
    case 'ideas':
      return '/create/ideas';
    case 'prompt':
    default:
      return '/';
  }
}

// a resume pointer that lands on a create screen (Ideas/Script) needs the flow's active draft
// id set first; 'result'/'generating' carry their own id in the route and stand alone.
export function resumeNeedsDraftId(resume) {
  const to = (resume || {}).to;
  return to === 'scripting' || to === 'script' || to === 'ideating' || to === 'ideas' || to === 'prompt';
}

export function isFirstRun({ runs = [], drafts = [], brands = [] } = {}) {
  const len = (x) => (Array.isArray(x) ? x.length : 0);
  return len(runs) === 0 && len(drafts) === 0 && len(brands) === 0;
}
